import { render, staticRenderFns } from "./holes-create-groups.vue?vue&type=template&id=06ef7e21"
import script from "./holes-create-groups.vue?vue&type=script&lang=js"
export * from "./holes-create-groups.vue?vue&type=script&lang=js"
import style0 from "./holes-create-groups.vue?vue&type=style&index=0&id=06ef7e21&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports